// extracted by mini-css-extract-plugin
export var sliderRange = "_pk-2";
export var sliderRoot = "_pk-0";
export var sliderThumb = "_pk-3";
export var sliderTrack = "_pk-1";